export default from './profile-cover';



// WEBPACK FOOTER //
// ./app/components/profile-cover/index.js